import { render, staticRenderFns } from "./ContactMenuEntry.vue?vue&type=template&id=b4cbc5dc&scoped=true"
import script from "./ContactMenuEntry.vue?vue&type=script&lang=js"
export * from "./ContactMenuEntry.vue?vue&type=script&lang=js"
import style0 from "./ContactMenuEntry.vue?vue&type=style&index=0&id=b4cbc5dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4cbc5dc",
  null
  
)

export default component.exports